import Vue from "vue";
import Vuex from "vuex";
import stores from "./storeIMS"

Vue.use(Vuex);
const store = new Vuex.Store(stores);
export default store;
